
import Header from './FunctionalComponents/Header/Header.js'
import Alert from "./FunctionalComponents/Alert/Alert.js";
import Footer from './FunctionalComponents/Footer/Footer.js';
import Sections from './FunctionalComponents/Sections/Sections.js';
import "./commonResource/css/bootstrap.css"
import "./commonResource/css/styles.css"
function App() {
  return (

  <>
  <Header/>
   <Alert/>
   <Sections/>
   <Footer/>
   
   </>


  );
}

export default App;
